import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import{ApiService} from '../../../services/api.service';
import { AlertController } from '@ionic/angular';
@Component({
  selector: 'app-input-nilai-ekskul',
  templateUrl: './input-nilai-ekskul.page.html',
  styleUrls: ['./input-nilai-ekskul.page.scss'],
})
export class InputNilaiEkskulPage implements OnInit {

  constructor(private route: ActivatedRoute, public router:Router, private api:ApiService, public alert:AlertController) { }

  ekskulID:any;
  tahun:any;
  semester:any='GASAL';
  ngOnInit() {
  	var id=this.route.snapshot.paramMap.get('id');
    this.ekskulID=id;
    this.getDataEkskul(id);
  }

  data:any={};
  getDataEkskul(id)
  {
  		this.api.data('ekskul/'+id,'get','').subscribe(data=>{
  			this.data=data;
  			this.getPeserta(data,'GASAL');
  			this.getPeserta(data,'GENAP');
  		})
  }

  loadingPeserta:boolean;
  dataPeserta:any={};
  getPeserta(ekskul,semester)
  {
  		this.loadingPeserta=true;
  		var param='semester='+semester+'&ekskulID='+ekskul.id;
  		this.api.data('ekskul/peserta?'+param,'get','').subscribe(data=>{
  			this.dataPeserta[semester]=data;
  			this.loadingPeserta=false;
  		})
  }
  async remove(id,idx) {
    const alert = await this.alert.create({
      header: 'Hapus Peserta',
      message: 'Anda yakin akan menghapus peserta ekstrakurikuler?',
      buttons: [
        {
          text: 'Batal',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            return false;
          }
        }, {
          text: 'YA',
          handler: () => {
            this.hapusPeserta(id,idx);
          }
        }
      ]
    });
    await alert.present();
  }
  loadingHapus:any={};
  hapusPeserta(id,idx)
  {
      this.loadingHapus[id]=true;
  		this.api.data('ekskul/'+id,'delete','').subscribe(data=>{
  			this.dataPeserta.splice(idx,1);
        this.loadingHapus[id]=false;
  		},error=>{
        this.loadingHapus[id]=false;
      })
  }
  loadingSimpan:boolean;
  simpan()
  {
  		this.loadingSimpan=true;
  		this.api.data('ekskul','post',this.dataPeserta[this.semester]).subscribe(data=>{
  			this.loadingSimpan=false;
  		},error=>{
        this.loadingSimpan=false;
      })
  }

}
